var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShadowsCasinoBlocks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 936,
    height: 971,
    viewBox: "0 0 936 971",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2004_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150 290.634C171.74 324.99 197.098 352.57 223.631 370.718C250.165 388.866 276.979 396.97 301.492 394.249C326.004 391.528 347.387 378.075 363.582 355.184C379.777 332.293 390.238 300.737 393.956 263.556L240.096 150.539L150 290.634Z",
    fill: "#8000FF",
    fillOpacity: 0.49
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2004_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424 660.053C456.777 711.852 494.806 753.752 534.423 781.718C574.039 809.684 613.908 822.772 650.188 819.723C686.469 816.673 717.938 797.588 741.563 764.307C765.189 731.025 780.175 684.669 785.078 629.703L555.226 456.002L424 660.053Z",
    fill: "#CD3980"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2004_11",
    x: 0,
    y: 0.538818,
    width: 543.956,
    height: 544.225,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur_2004_11"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2004_11",
    x: 274,
    y: 306.002,
    width: 661.078,
    height: 664.154,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur_2004_11"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadowsCasinoBlocks);
export default __webpack_public_path__ + "static/media/shadowsCasinoBlocks.bbb3c4a0d218eccc9446619aebbacfd8.svg";
export { ForwardRef as ReactComponent };